import { render } from "./InitiativeMainInfo.vue?vue&type=template&id=7bbdc947&scoped=true"
import script from "./InitiativeMainInfo.vue?vue&type=script&lang=js"
export * from "./InitiativeMainInfo.vue?vue&type=script&lang=js"

import "./InitiativeMainInfo.vue?vue&type=style&index=0&id=7bbdc947&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbdc947"]])

export default __exports__